import { FC } from 'react';
import { Alert, AlertProps, Box, Text, TextProps } from 'roo-ui/components';

const ImportantInfoAlertBase: FC<AlertProps> = ({ children, ...props }) => (
  <Alert variant="info" icon={{ name: 'infoOutline', size: 24 }} {...props}>
    <Box ml={2}>{children}</Box>
  </Alert>
);

const Heading: FC<TextProps> = (props) => <Text as="div" fontSize="lg" fontWeight="bold" {...props} />;
const Body: FC<TextProps> = (props) => <Text as="div" fontSize="sm" color="emperor" mt={2} {...props} />;

export const ImportantInfoAlert = Object.assign(ImportantInfoAlertBase, { Heading, Body });
